import { Outlet, createRootRoute } from "@tanstack/react-router";

import { QueryProviders } from "@/presentation/providers/query.provider";
import { AuthProvider } from "@/presentation/providers/auth.provider";
import { WorkspaceProvider } from "@/presentation/providers/workspace.provider";
import { Toaster } from "@monorepo-apps/ui/src/components/sonner";

function RootLayout() {
  return (
    <QueryProviders>
      <AuthProvider>
        <WorkspaceProvider>
          <Outlet />
          <Toaster position="bottom-right" />
        </WorkspaceProvider>
      </AuthProvider>
    </QueryProviders>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="p-8 font-mono text-sm">
      <h1 className="mb-2 font-semibold">Something broke</h1>
      <pre className="text-muted-foreground">{error.message}</pre>
    </div>
  ),
});
